import { Linkedin, Link2 } from "lucide-react";
import { toast } from "sonner";

export default function ShareBar({ title, variant = "column" }) {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied", { description: title });
    } catch {
      toast.error("Could not copy link");
    }
  };

  const btn =
    "inline-flex items-center gap-2 border border-white/15 px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300 transition-colors duration-300 hover:border-gold/60 hover:text-gold";

  return (
    <div className={variant === "column" ? "flex flex-col items-start gap-3" : "flex flex-wrap items-center gap-3"} data-testid={`share-bar-${variant}`}>
      <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">Share</span>
      <a
        href={linkedin}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`share-linkedin-${variant}`}
        className={btn}
        aria-label="Share on LinkedIn"
      >
        <Linkedin size={13} /> LinkedIn
      </a>
      <button type="button" onClick={copy} data-testid={`share-copy-${variant}`} className={btn}>
        <Link2 size={13} /> Copy link
      </button>
    </div>
  );
}
